import React from 'react';
import classNames from 'classnames';
import Counter, {
  COUNTER_VARIANTS,
} from 'components/Counter/Counter.component';

import './EnterpriseCustomOptionsWrapper.styles.scss';

type EnterpriseCustomOptionsWrapperProps = {
  className?: string;
  title: string;
  count: number;
  description?: string;
};

const EnterpriseCustomOptionsWrapper: React.FC<
  EnterpriseCustomOptionsWrapperProps
> = (props) => {
  const { children, className, title, count, description } = props;

  const classes = classNames('enterprise-custom-options-wrapper', className);

  return (
    <div className={classes}>
      <div className="heading">
        <p>{title}</p>
        <Counter count={count} variant={COUNTER_VARIANTS.GREY} />
      </div>

      {description && <p className="description">{description}</p>}

      {children}
    </div>
  );
};

export default EnterpriseCustomOptionsWrapper;
